import React, { useEffect, useRef, useState } from "react";
import ChartJS from "../../../tools/ChartSetup";
import { Box, Heading, Spinner, useTheme } from "@chakra-ui/react";
import axios from "axios";
import { Bar } from "react-chartjs-2";

const Chart6Region = ({ supplier, retailer, region }) => {
  const theme = useTheme();
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
        const fetchData = async () => {
          setLoading(true);
          try {
            const res = await axios.post(
              `${process.env.REACT_APP_API_URL}/rep_sales/chart6_chk_region`,
              { supplier, retailer, region, userid: localStorage.getItem("userid") },
              { signal: controller.signal }
            );
            const raw = res.data.data;
            const data = raw.map(i => ({
              ...i,
              backgroundColor: i.value < 0 ? "#ef4444" : "#58c087",
            }));
            setChartData({
              labels: data.map(i =>
                new Date(i.date).toLocaleDateString("en-GB", { year: "numeric", month: "short" })
              ),
              datasets: [
                {
                  label: "% vs LY",
                  data: data.map(i => i.value),
                  backgroundColor: data.map(i => i.backgroundColor),
                  borderColor: "transparent",
                  borderWidth: 0,
                  borderRadius: { topLeft: 4, topRight: 4 },
                  fill: true,
                },
              ],
            });
          } catch (err) {
            if (!axios.isCancel(err)) console.error("chart6 region fetch failed", err);
          } finally {
            if (!controller.signal.aborted) setLoading(false);
          }
        };
        fetchData();
        return () => {
          controller.abort();
          if (chartRef.current?.chartInstance) chartRef.current.chartInstance.destroy();
        };
     }, [supplier, retailer, region]);

  if (loading) return <Spinner />;

  return (
    <Box height="100%">
      <Heading size="xs" color="gray.600" mb={2} fontWeight="600">
        Year-over-Year Growth ({region})
      </Heading>
      {chartData && (
        <Bar
          ref={chartRef}
          data={chartData}
          options={{
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              datalabels: {
                display: true,
                align: "top",
                anchor: "end",
                color: "#6b7280",
                backgroundColor: "transparent",
                borderRadius: 0,
                padding: 2,
                font: { size: 9 },
                formatter: function (value) {
                  if (typeof value === "number") {
                    return `${value.toFixed(1)}%`;
                  }
                  return value;
                },
              },
              tooltip: {
                backgroundColor: "rgba(255,255,255,0.95)",
                titleColor: "#374151",
                bodyColor: "#6b7280",
                borderColor: "#e5e7eb",
                borderWidth: 1,
                cornerRadius: 6,
                titleFont: { size: 12, weight: "600" },
                bodyFont: { size: 12 },
                padding: 10,
                callbacks: {
                  label: function (ctx) {
                    return ` ${ctx.raw.toFixed(1)}%`;
                  },
                },
              },
              filler: { propagate: false },
            },
            scales: {
              x: {
                ticks: { color: "#9ca3af", font: { size: 11 } },
                grid: { display: false },
              },
              y: {
                ticks: { color: "#9ca3af", font: { size: 11 } },
                grid: {
                  display: true,
                  color: "rgba(229,231,235,0.5)",
                  drawBorder: false,
                  borderDash: [3, 3],
                },
              },
            },
          }}
        />
      )}
    </Box>
  );
};

export default Chart6Region;
